import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import Button from '../components/Button/Button.js'

class Contact extends Component {
  
  componentDidMount(){
    window.document.title = "Contact - Pattycake";
  }

  render(){
    return <div className="body-stretch">
      <Header transparent={true}/>
      <div className="stretched">
        <div className="section-breaker">
          <div className="container">
            <div className="row justify-content-center row-push-down">
              <div className="col-md-4">
              
                <h1 className="row-push-down  text-center">Hey there 👋</h1>
                <p className="lead">
                  Pattycake is built and operated by a miniscule, remote, and passionate team.
                </p>
                <p className="lead">
                   We'd love to hear from you and learn how to improve Pattycake to better suit your needs.
                </p>
                <p>The fastest way to reach us is by sending an email to <a href="mailto:hi@pattycake.io">hi@pattycake.io</a>.</p>
                <p>You can also follow our <a href="https://twitter.com/pattycakeio" target="_blank" rel="noopener noreferrer">Twitter</a> for the latest feature updates, and our <a href="https://instagram.com/pattycakeio" target="_blank" rel="noopener noreferrer">Instagram</a> for pictures of pretty patterns.</p>
                <p>Pattycake is a collaboration between <nobr><a href="https://theschool.studio" target="_blank" rel="noopener noreferrer">School Studio</a></nobr> and <nobr><a href="https://not.yet.digital" target="_blank" rel="noopener noreferrer">Not Yet Digital LLC</a></nobr></p>
                <p>
                  Chat soon,<br/>
                  The Pattycake Team 🎂
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  }
}

export default Contact
  


// WEBPACK FOOTER //
// ./src/routes/Contact.js